import { BimSection } from "./bim-section.interface";

export class CreateBimSectionDto {
  name: string;
  description: string;
  level: number;
  structureId: string;
  plans?: SectionPlan[]

  constructor(bimSection: BimSection) {
    this.name = bimSection.name;
    this.description = bimSection.description;
    this.level = bimSection.level;
    this.structureId = bimSection.structureId;
    this.plans = bimSection.plans;
  }
}

export class UpdateBimSectionDto {
  name?: string;
  description?: string;
  structureId?: string;
  level?: number;
  plans?: SectionPlan[]

  constructor(bimSection: BimSection) {
    this.name = bimSection?.name;
    this.description = bimSection?.description;
    this.structureId = bimSection?.structureId;
    this.level = bimSection?.level;
    this.plans = bimSection?.plans;
  }
}

export interface SectionPlan {
    "planId": string,
    "versionId": string,
    "transform"?: {
      "scaleX": number,
      "scaleY": number,
      "translateX": number,
      "translateY": number,
      "plan1Point1"?: {
        "x": number,
        "y": number,
        "z": number,
      },
      "plan1Point2"?: {
        "x": number,
        "y": number,
        "z": number,
      },
      "plan2Point1"?: {
        "x": number,
        "y": number
      },
      "plan2Point2"?: {
        "x": number,
        "y": number
      }
    }
}